import "./index.scss";
import "../../locales/i18n";

import cx from "classnames";
import React, { createRef, useEffect, useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import { /*useDispatch,*/ useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import ChatCard from "@/messenger/components/ChatCard";
import LoadedSettingsCard from "@/messenger/components/ChatCard/LoadedSettingsCard";
import { SETTINGS } from "@/messenger/constants/routing";
import { isAppLoadedSelector } from "@/messenger/ducks/selectors/aggregate";
import { getExoHandler } from "@/messenger/routes/helper";
import { TStore } from "@/messenger/types/store.types";
import { EDeviceType } from "@/messenger/utils/deviceType";
const baseClassName = "c-settings-card-list";

const ChatCardList = (props) => {
    const { t } = useTranslation();
    //const dispatch = useDispatch();
    const mode = props.mode ? props.mode : "personal";
    const history = useHistory();
    const state = useSelector((s: TStore) => s);
    const { id: parentSettingsId, child: childSettingsId } = useParams<any>();

    const isAppLoaded = useSelector(isAppLoadedSelector);
    const scrollbarRef = useRef<any>(null);
    const [elRefs, setElRefs] = useState<Array<any | null>>([]);
    const [settings, setSettings] = useState<Array<any | null>>([]);

    useEffect(() => {
        setElRefs([1, 2, 3].map((_, i) => elRefs[i] || createRef()));
        
        (async () => {
            const appSettings = await getExoHandler("project",null,"context","settings");
            const globalSettings = await getExoHandler("product","textkit","context","settings");
            const data = appSettings?.context ? appSettings.context : globalSettings;
            if(data) {
                setSettings(data);
            }
        })();
    }, []);

    const onChatCardSelect = (id: string, parentId: string) => {
        history.push(`/${SETTINGS}/${parentId?`${parentId}/`:""}${id?`${id}`:""}`);
    };

    const onChatCardHover = (conversationId: string) => {
        
    };

    const renderLoading = (): React.ReactNode => {
        const result = [];
        for (let i = 0; i < 5; i++) {
            result.push(<LoadedSettingsCard key={i} />);
        }
        return result;
    };

    const isMobile = state.general.deviceType === EDeviceType.MOBILE;

    const renderSettingsList = () => {
        

        return settings.map(s => {
                const isActive = childSettingsId ? childSettingsId === s.id : parentSettingsId === s.id;
                const isParent = !parentSettingsId;
                if (isMobile) {}
                if (s.type === mode) {
                    const topicName = s?.label ? t(s?.label) : "";
                    return <ChatCard
                        key={s.id}
                        domId={isActive ? "SETTINGS_ACTIVE" : `SETTINGS_${s.id}`}
                        header={topicName}
                        subheader={"subtitle"}
                        rightLabel={isParent?"":""}
                        isActive={childSettingsId ? childSettingsId === s.id : s.id === parentSettingsId}
                        onClick={() => onChatCardSelect(s.id,s.type)}
                        onHover={() => onChatCardHover(s.id)}
                        isSmsCapable={true}
                        isCompact={true}
                        isRounded={true}
                    />;
                }
            });
    };

    
    const handleOnScroll = () => {
        
    };

    let childComponent: JSX.Element | React.ReactNode = null;

    if (!isAppLoaded) {
        childComponent = renderLoading();
    } else {
        childComponent = renderSettingsList();
    }

    const classNames = cx({
        [`${baseClassName}__wrapper`]: true,
    });
    return (
        <div className={baseClassName} data-testid="chatCardList">
            <div className={classNames}>
                <Scrollbars ref={scrollbarRef} hideTracksWhenNotNeeded={true} onScroll={handleOnScroll}>
                    {childComponent}
                </Scrollbars>
            </div>
        </div>
    );
};

export default ChatCardList;